export const rs = {
  badge: 'Znak',
  open: 'Otvoriti',
  close: 'Zatvoriti',
  dismiss: 'Odbaciti',
  confirmEdit: {
    ok: 'U redu',
    cancel: 'Otkaži',
  },
  dataIterator: {
    noResultsText: 'Nema pronađenih zapisa',
    loadingText: 'Zapis se učitava...',
  },
  dataTable: {
    itemsPerPageText: 'Stavki po strani:',
    ariaLabel: {
      sortDescending: 'Sortirano opadajuće.',
      sortAscending: 'Sortirano uzlazno.',
      sortNone: 'Nije sortirano.',
      activateNone: 'Aktivirajte da uklonite sortiranje.',
      activateDescending: 'Aktivirajte za sortiranje opadajuće.',
      activateAscending: 'Aktivirajte za sortiranje uzlazno.',
    },
    sortBy: 'Sortiraj po',
  },
  dataFooter: {
    itemsPerPageText: 'Zapisa po strani:',
    itemsPerPageAll: 'Sve',
    nextPage: 'Sledeća strana',
    prevPage: 'Prethodna strana',
    firstPage: 'Prva strana',
    lastPage: 'Poslednja strana',
    pageText: '{0}-{1} od {2}',
  },
  dateRangeInput: {
    divider: 'do',
  },
  datePicker: {
    itemsSelected: 'Izabrano {0}',
    range: {
      title: 'Izabrani datumi',
      header: 'Unos datuma',
    },
    title: 'Izbor datuma',
    header: 'Unos datuma',
    input: {
      placeholder: 'Unesite datum',
    },
  },
  noDataText: 'Nema podataka',
  carousel: {
    prev: 'Prethodni slajd',
    next: 'Sledeći slajd',
    ariaLabel: {
      delimiter: 'Slajd {0} od {1}',
    },
  },
  calendar: {
    moreEvents: 'Još {0}',
    today: 'Danas',
  },
  input: {
    clear: 'Obriši {0}',
    prependAction: '{0} prethodnih akcija',
    appendAction: '{0} dodatnih akcija',
    otp: 'Molimo unesite OTP simbole {0}',
  },
  fileInput: {
    counter: 'Fajlova: {0}',
    counterSize: 'Fajlova: {0} (ukupno {1})',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Izbor vremena',
  },
  pagination: {
    ariaLabel: {
      root: 'Navigacija po stranicama',
      next: 'Sledeća strana',
      previous: 'Prethodna strana',
      page: 'Pređi na stranu {0}',
      currentPage: 'Trenutna strana, Strana {0}',
      first: 'Prva strana',
      last: 'Poslednja strana',
    },
  },
  stepper: {
    next: 'Sledeći',
    prev: 'Prethodni',
  },
  rating: {
    ariaLabel: {
      item: 'Ocena {0} od {1}',
    },
  },
  loading: 'Učitavanje...',
  infiniteScroll: {
    loadMore: 'Učitaj još',
    empty: 'Nema više za učitavanje',
  },
}
